import React, { useState } from "react";
import "./inventory-theme.css";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";

const InventoryListTable = ({
  items,
  onEdit,
  onDelete,
  onStockClick,
  loading,
}) => {
  const [search, setSearch] = useState("");
  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    {
      Header: "Items Id",
      accessor: "id",
    },
    {
      Header: "Items Name",
      accessor: "itemsName",
    },
    {
      Header: "Category Name",
      accessor: "categoryName",
    },
    {
      Header: "Stock",
      accessor: "stock",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Expiry",
      accessor: "expiry",
    },
  ];

  const tableData = filteredItems.map((item) => {
    const isLow = item.quantity <= item.minThreshold;

    return {
      id: item.id,
      itemsName: <span className="fw-semibold">{item.name}</span>,
      categoryName: <span className="badge-soft">{item.category}</span>,
      stock: (
        <span className="fw-semibold">
          {item.quantity} <small>{item.unit}</small>
          <i
            className="bi bi-plus-circle text-primary ms-2 stock-plus"
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => onStockClick(item)}
          ></i>
        </span>
      ),
      status: isLow ? (
        <span className="status-pill status-low">
          <i className="bi bi-exclamation-circle me-2"></i>
          Low Stock
        </span>
      ) : (
        <span className="status-pill status-in">In Stock</span>
      ),
      expiry: (
        <span className="fw-bold text-danger">
          {item.expiry_date
            ? new Date(item.expiry_date).toLocaleDateString()
            : "-"}
        </span>
      ),
      actions: (
        <>
          <button type="button" className="btn" onClick={() => onEdit(item)}>
            <i className="bi bi-pencil-square text-primary"></i>
          </button>
          <button
            type="button"
            onClick={() => onDelete(item.id)}
            className="btn deleterow"
          >
            <i className="bi bi-trash text-danger"></i>
          </button>
        </>
      ),
    };
  });

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <p className="text-center py-4">Loading...</p>
      ) : (
        <DataTable columns={columns} data={tableData} />
      )}
      {/* <DataTableFooter dataT={tableData} /> */}
    </>
  );
};

export default InventoryListTable;
